// @ts-nocheck
// Settings → Phone. The phone system's own tab: how the line answers, who it
// rings, and what the assistant is allowed to do.
//
// Sub-pages route as /settings/phone/<sub>; `call-flow` is the default and is
// the only one today. Editing, version history and the AI grant panel are
// step 2 and land as siblings here.
import React from 'react';
import CallFlow from '../phone/CallFlow';

export default function PhoneTab({ sub }) {
  return (
    <div className="sv2-body">
      <div className="sv2-col sv2-col--tool">
        {(!sub || sub === 'call-flow') && <CallFlow />}
      </div>
    </div>
  );
}
